import styled from "styled-components"

import {RouterLink} from "../../Link"
import {MenuItem} from "."
import {minWidthMedia} from "../../global/media"

interface MenuListItemProps extends Pick<MenuItem, "isCategory"> {}

interface MenuItemLinkProps extends Pick<MenuItem, "isCategory" | "color"> {
  isCurrent: boolean
}

export const Nav = styled.nav`
  border: none;
  max-width: 100%;
  margin-top: ${({theme}) => theme.spacing.one};
  ${minWidthMedia.tablet`
    border-right: 1px solid ${({theme}) => theme.colors.utility.highlight};
    padding-right: ${({theme}) => theme.spacing.four};
    max-width: 330px;
  `}
`

export const Ul = styled.ul`
  padding: 0;
`

export const MenuListItem = styled.li<MenuListItemProps>`
  list-style-type: none;

  ${({theme, isCategory}) =>
    isCategory &&
    `
    :not(:first-of-type) {
      padding-top: ${theme.spacing.four};
    }
  `}
`

export const MenuItemLink = styled(RouterLink)<MenuItemLinkProps>`
  display: flex;
  width: 100%;
  height: 100%;
  padding: ${({theme, isCategory}) => (isCategory ? `0 0 ${theme.spacing.one}` : `${theme.spacing.one}`)};
  text-decoration: none;
  color: ${({color, theme}) => color || theme.colors.utility.ink};
  border-radius: 5px;

  ${({isCategory, theme}) =>
    isCategory &&
    `
    font-family: ${theme.font.semibold};
    font-size: 16px;
    color: ${theme.colors.utility.ink};
  `}

  ${({isCurrent, isCategory, theme}) =>
    isCurrent &&
    !isCategory &&
    `
    font-family: ${theme.font.semibold};
    color: ${theme.colors.primary1};
  `}

  ${({theme, isCategory}) => theme.mediaQueries.maxWidthMedia.tablet`
    padding: ${!isCategory ? theme.spacing.two : `${theme.spacing.two} 0 ${theme.spacing.one} ${theme.spacing.one}`};
  `}

  &:hover,
  &:focus {
    color: ${({isCurrent, isCategory, theme}) => (isCurrent && !isCategory ? theme.colors.primary1 : theme.colors.utility.ink)};
    ${({isCategory, theme}) => !isCategory && `background-color: ${theme.colors.utility.highlight};`}
    text-decoration: none;
  }
  &:active {
    ${({theme, isCategory}) => !isCategory && `color: ${theme.colors.primary1};`}
    font-family: ${({theme}) => theme.font.semibold};
  }
`
